<template>
  <div class="row">
    <div class="small-12 columns">
      <div class="row">
        <div class="small-3 columns">Institution</div>
        <div class="small-9 columns">
          <input
            v-model="institution"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
    </div>
    <div class="small-12 columns">
      <div class="row">
        <div class="small-3 columns">Code</div>
        <div class="small-9 columns">
          <input v-model="code" type="text" class="input-box-course-creators" />
        </div>
      </div>
    </div>
    <div class="small-12 columns">
      <button @click="addInstitution">Add Institution</button>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      institution: undefined,
      code: undefined,
    }
  },
  methods: {
    addInstitution() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}institution/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { name: this.institution, government_code: this.code },
      }).then(() => {
        this.$router.push("/institution/")
      })
    },
  },
}
</script>
